import { server } from "../api";
import axios from "axios";
export default {
  Initialize: async (IP, port) => {
    try {
      let response = await axios.get(`http://${IP}:${port}/init_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetData: async (IP, port) => {
    try {
      let response = await axios.get(`http://${IP}:${port}/get_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetChartData: async (id, days) => {
    try {
      const response = await axios.get(`${server}gasmonitor/data`, {
        params: { id, days },
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetBounds: async (id) => {
    try {
      const response = await axios.get(`${server}gasmonitor/bounds`, {
        params: { id },
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdateBounds: async (mobileID, upperBound, lowerBound, tolerance) => {
    try {
      const response = await axios.post(`${server}gasmonitor/bounds/update`, {
        mobileID: mobileID,
        upperBound: upperBound,
        lowerBound: lowerBound,
        tolerance: tolerance,
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetMakeUp: async (id) => {
    try {
      const response = await axios.get(`${server}gasmonitor/makeup`, {
        params: { id },
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdateMakeUp: async (mobileID, makeUp) => {
    try {
      const response = await axios.post(`${server}gasmonitor/makeup/update`, {
        mobileID: mobileID,
        makeUp: makeUp ? 1 : 0,
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  RestartServer: async (mobileID) => {
    try {
      const response = await axios.post(`${server}gasmonitor/restart_server`, {
        mobileID: mobileID,
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  ReloadMQTTConfig: async () => {
    try {
      const response = await axios.post(`${server}gasmonitor/mqtt/reload-config`);
      return response.data;
    } catch (err) {
      return err.response?.data || { code: 500, message: 'Network error' };
    }
  },

  UpdateHeatRiskTopic: async (mobileID, topic) => {
    try {
      const response = await axios.post(`${server}gasmonitor/heat-risk-topic/update`, {
        mobileID: mobileID,
        topic: topic || '',
      });
      return response.data;
    } catch (err) {
      return err.response?.data || { code: 500, message: 'Network error' };
    }
  }
};